import React from "react";
import { Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      style={{ 
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#f8f9fa",
        width: "100%",
        padding: "15px 0",
        marginTop: "auto"
      }}
    >
      <Container>
        <div className="d-flex justify-content-center align-items-center">
          <p 
            style={{ 
              fontSize: "0.9rem", 
              margin: 0,
              color: "#5D6D7E",
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: "0.3px"
            }}
          >
            &copy; {currentYear} <span style={{ fontWeight: 600 }}>Verto</span> | <a 
              href="https://vertocommodities.io" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                textDecoration: "none", 
                color: "#3498DB",
                transition: "color 0.2s ease"
              }}
              onMouseOver={(e) => e.target.style.color = "#2980B9"}
              onMouseOut={(e) => e.target.style.color = "#3498DB"}
            >
              vertocommodities.io
            </a>
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;